import { Component, OnInit, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { GlobalConstants } from '../../../../common/constants/global.constant';
import { OemService } from '../../../../../app/core/routing/services/oem/oem.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { first } from 'rxjs/internal/operators/first';
import { TileThumbnail, CreateTileThumbnailResponse, GetAllTileThumbnailByAutoId, AssetThumbnailViewModel } from './interfaces/upload-thumbnai.i';
import { Router } from '@angular/router';
import { RouterConstants } from '../../../../core/routing/constants/app-paths.constant';
import { OemConstants } from '../../../../core/routing/services/oem/constants/oem.constants'
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'iposcen-upload-thumbnail',
  templateUrl: './upload-thumbnail.component.html',
  styleUrls: ['./upload-thumbnail.component.scss']
})
export class UploadThumbnailComponent implements OnInit {
  @ViewChild('thumbnailModal') thumbnailModal: ElementRef;
  @Output() readonly setSideNavValue = new EventEmitter();

  deleteTooltipLabel = GlobalConstants.DELETE;
  thumbnailDeleteButton = GlobalConstants.MEDIA;
  thumbnailDeleteName: string;
  thumbnailToDelete: string;
  isThumbnailAvailable: boolean;
  autoId: string;
  type: string;
  typeConfiguration: string = OemConstants.IMAGE_SLASH;
  tileThumbnail: AssetThumbnailViewModel[] = [];
  uploadThumbnailSortValue = GlobalConstants.UPLOAD_DATE;
  uploadDateOption = GlobalConstants.UPLOAD_DATE;
  fileNameOption = GlobalConstants.FILE_NAME;
  thumbnailLabel = $localize`:@@upload-thumbnail.header.sing:Tile Thumbnail`;
  isImageSizeError: boolean;
  isImageTypeError: boolean;
  isImageUploadError: boolean;
  isimageFormat: boolean;

  @ViewChild('ThumbnailDeleteModal') thumbnailDeletePopup: ElementRef;
  private ngUnsubscribe = new Subject<boolean>();
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  deleteThumbnailData: any;
  deleteThumbnailLable: any;
  isDeleteDisable: boolean;
  noThumbnail: boolean;
  constructor(private oemservice: OemService, private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.type = OemConstants.TILE_THUMBNAIL;
    this.autoId = this.oemservice.getAutoId();
    this.noThumbnail = false;
    this.getAllThumnailByAutoId();

  }
  open(data) {
    this.deleteThumbnailLable = data.fileName;
    this.deleteThumbnailData = data;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.isDeleteDisable = false;
    this.modalRef = this.modalService.open(this.thumbnailDeletePopup, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
    this.deleteThumbnailData = '';

  }

  dismiss() {
    this.modalRef.dismiss();
    this.deleteThumbnailData = '';
  }
  deleteThumbnail() {
    this.oemservice.deleteVideo(this.deleteThumbnailData.assetID)
      .pipe()
      .subscribe(res => {
        this.close();
        this.tileThumbnail = [];
        this.getAllThumnailByAutoId();
      },err=>{
        this.isDeleteDisable = true;
      });
  }
  getAllThumnailByAutoId() {
    this.oemservice.getAllAssetsByAutoId(this.type)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllAthumbnailResponse => {
        const thumbnail = [];
        const getThumnailByAutoId: GetAllTileThumbnailByAutoId = getAllAthumbnailResponse as GetAllTileThumbnailByAutoId;
        if(getThumnailByAutoId.assets.length === 0){
          this.noThumbnail = true;
        }else{
          this.noThumbnail = false;
        }
        
        getThumnailByAutoId.assets.forEach(assets => {
          const reader = new FileReader();
          const thumbnailViewModel: AssetThumbnailViewModel = assets as AssetThumbnailViewModel;

          this.oemservice.getAssetByAutoIdAndAssetId(assets.assetID, OemConstants.SLASH_THUMBNAIL)
            .pipe(takeUntil(this.ngUnsubscribe))
            .pipe(first())
            .subscribe(imageData => {
              reader.addEventListener('load', () => {
                thumbnailViewModel.imageData = reader.result;
                thumbnailViewModel.fileName = assets.assetName;
                this.tileThumbnail.push(thumbnailViewModel);
                if(this.tileThumbnail.length === 0){
                  this.noThumbnail = false;
                }else{
                  this.noThumbnail= true;
                }
                this.tileThumbnail.forEach(ele => {
                  ele.shortFileName = this.getShortFileName(ele.fileName);
                  ele.updatedTime = new Date(ele.updatedTime);
                  ele.updateTimeDisplay = new Date(ele.updatedTime).toLocaleString()
                    .replace(',', '');
                })
                this.sortBy('uploadDate');
              }, false);

              if (imageData) {
                reader.readAsDataURL(imageData);
              }

            },

              error => {
                // do something
              });
        })
      },
        error => {
          // do something
        });
    if (this.tileThumbnail.length > 0) {
      this.isThumbnailAvailable = true;
    } else {
      this.isThumbnailAvailable = false;
    }
  }


  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  openDeleteModal() {
    this.openModal(this.thumbnailModal)
  }

  goBack() {
    this.router.navigate([RouterConstants.MODEL_SKU_INFO_LINK]);
  }

  goNextTab() {
    this.setSideNavValue.emit('upload_image');
  }

  sortBy(sortValue: string) {
    switch (sortValue) {
      case 'uploadDate': {
        this.uploadThumbnailSortValue = GlobalConstants.UPLOAD_DATE;
        this.tileThumbnail.sort((logo1, logo2) => (logo2.updatedTime as any) - (logo1.updatedTime as any));
        break;
      }
      case 'fileName': {
        this.uploadThumbnailSortValue = GlobalConstants.FILE_NAME;
        this.tileThumbnail.sort((logo1, logo2) =>
          logo1.assetName.localeCompare(logo2.assetName));
        break;
      }
      default:
        break;
    }
  }

  getShortFileName(fileName: string): string {
    let finalName: string;
    var str = fileName;
    var arr = str.split(".");
    var lastVal = arr.pop();
    var firstVal = arr.join(".");

    if (firstVal.length > 12) {
      let flname = firstVal;
      let extension = lastVal;
      flname = firstVal.substring(0, 12);
      finalName = `${flname}...${extension}`;
    } else {
      finalName = fileName;
    }
    return finalName;
  }

  processFile(imageInput) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();
    const fileType = file.type.split('/')[1];
    if (file.type.split('/')[0] === GlobalConstants.FILE_TYPE_IMAGE) {
      this.isImageSizeError = file.size > GlobalConstants.UPLOAD_LOGO_IMAGE_SIZE_5MB;
      this.isImageTypeError = fileType !== GlobalConstants.CONTENT_TYPE_JPEG &&
        fileType !== GlobalConstants.CONTENT_TYPE_PNG &&
        fileType !== GlobalConstants.CONTENT_TYPE_GIF;
      this.isImageUploadError = (this.isImageSizeError || this.isImageTypeError || (this.isImageSizeError && this.isImageTypeError));
      this.isimageFormat = true;
    } else {
      this.isimageFormat = false;
      this.isImageTypeError = true;
      this.isImageUploadError = true;
    }
    if (!this.isImageUploadError) {
      reader.addEventListener('load', (event: any) => {
        const assets = {
          type: `${this.typeConfiguration}${fileType}`,
          assetName: file.name,
          assetCategory: OemConstants.TILE_THUMBNAIL
        };
        this.oemservice.uploadAssets(JSON.stringify(assets))
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe()
          .subscribe(createAsset => {
            const createTileThumbnailResponse: CreateTileThumbnailResponse = createAsset as CreateTileThumbnailResponse;
            const assetThumbnailViewModel: AssetThumbnailViewModel = createTileThumbnailResponse.assets as AssetThumbnailViewModel;
            
            //PATCH Endpoint to insert the downloadURL
            this.oemservice.updateDownloadURL(this.autoId, createAsset.assets.assetID, fileType, 'thumbnail')
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(res => {

              })

            this.oemservice.uploadImage(file, createAsset.assets.assetID, file.name.split('.').pop(), this.autoId, OemConstants.THUMBNAIL_ASSETS_PATH)
              .pipe(takeUntil(this.ngUnsubscribe))
              .pipe(first())
              .subscribe(() => {
                assetThumbnailViewModel.imageData = event.target.result;
                assetThumbnailViewModel.shortFileName = this.getShortFileName(file.name);;
                assetThumbnailViewModel.fileName = file.name;
                assetThumbnailViewModel.updatedTime = new Date(assetThumbnailViewModel.updatedTime);
                assetThumbnailViewModel.updateTimeDisplay = new Date(assetThumbnailViewModel.updatedTime).toLocaleString()
                  .replace(',', '');
                this.tileThumbnail.push(assetThumbnailViewModel);
                this.sortBy('uploadDate');
              },

                error => {
                  // do something
                });
          },
            error => {
              // do something
            });
      });
    }
    reader.readAsDataURL(file);
  }

}
